import { render, staticRenderFns } from "./toPay.vue?vue&type=template&id=fa2049a0&scoped=true&"
import script from "./toPay.vue?vue&type=script&lang=js&"
export * from "./toPay.vue?vue&type=script&lang=js&"
import style0 from "./toPay.vue?vue&type=style&index=0&id=fa2049a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2049a0",
  null
  
)

export default component.exports